export class InfoWindowSingleton {
    private static instance: google.maps.InfoWindow;

    private constructor() { }

    public static getInstance(): google.maps.InfoWindow {
        if (!this.instance) {
            this.instance = new google.maps.InfoWindow();
        }

        return this.instance;
    }

    public static clearListeners(): void {
        if (this.instance) {
            google.maps.event.clearInstanceListeners(this.instance);
        }
    }
}